import create from 'zustand';
import { persist } from 'zustand/middleware';

const INITIAL_STATE = {
  score: 0,
  count:0
};

const useCartQuantity = create(
  persist(
    (set, get) => ({
      ...INITIAL_STATE,
      setScore: (payload) => {
        set({
          ...get(),
          score: payload,
        });
      },
      setCount: (payload) => {
        set({
          ...get(),
          count: payload,
        });
      },
    }),
    {
      name: 'cart_quantity',
    },
  ),
);

export default useCartQuantity;
